
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { ContextType } from "../authorization";
import { usePermissionMatrix } from "./usePermissionMatrix";

import { UserRole } from "@/types/user/userType";

const useUserRoleOptions = (context: ContextType, editingUserRole?: string) => {
  const { t } = useTranslation();

  const { canManageRole } = usePermissionMatrix();
  const getRoleOptions = useCallback(() => {

    const canShowRole = (role: UserRole) =>
      canManageRole(role) || editingUserRole === role;

    const options = []

    if (context === "client") {
      if (canShowRole(UserRole.MANAGER)) {
        options.push({
          value: "Manager",
          label: t("common.manager"),
          description: t("client.userManagement.addUser.manager.description"),
        });
      }
      if (canShowRole(UserRole.SPECTATOR)) {
        options.push({
          value: "Spectator",
          label: t("common.spectator"),
          description: t("client.userManagement.addUser.spectator.description"),
        });
      }

      return options;
    }

    if (canShowRole(UserRole.ADMIN)) {
      options.push({
        value: "Admin",
        label: t("common.admin"),
        description: t("admin.userManagement.addUser.admin.description"),
      });
    }
    if (canShowRole(UserRole.SUPER_ADMIN)) {
      options.push({
        value: "SuperAdmin",
        label: t("common.superAdmin"),
        description: t("admin.userManagement.addUser.superAdmin.description"),
      });
    }

    return options;

  }, [canManageRole, editingUserRole, context, t]);

  return {
    getRoleOptions,
  };
};

export default useUserRoleOptions;